/**
 * Development utility to clear cache on startup
 * Only runs in development mode
 */

const DEV_CACHE_CLEAR_KEY = 'dev_cache_cleared_session';

export const clearCacheOnStartup = async () => {
  // Only run in development
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  // Check if we've already cleared cache this session
  const sessionId = sessionStorage.getItem(DEV_CACHE_CLEAR_KEY);
  const currentSessionId = Date.now().toString();
  
  if (sessionId === currentSessionId) {
    return; // Already cleared this session
  }

  console.log('🧹 Development mode: Clearing stale cache...');
  
  try {
    // Clear old Supabase auth data
    const keysToRemove: string[] = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.includes('supabase') || 
        key.includes('auth') ||
        key.includes('sb-')
      )) {
        keysToRemove.push(key);
      }
    }
    
    keysToRemove.forEach(key => {
      console.log(`  Removing: ${key}`);
      localStorage.removeItem(key);
    });
    
    // Clear IndexedDB databases
    if ('indexedDB' in window) {
      const databases = await indexedDB.databases();
      for (const db of databases) {
        if (db.name?.includes('supabase')) {
          console.log(`  Deleting IndexedDB: ${db.name}`);
          await indexedDB.deleteDatabase(db.name);
        }
      }
    }
    
    // Mark this session as cleared
    sessionStorage.setItem(DEV_CACHE_CLEAR_KEY, currentSessionId);
    
    console.log('✅ Cache cleared for development');
  } catch (error) {
    console.error('Error clearing dev cache:', error);
  }
};
